/* import __COLOCATED_TEMPLATE__ from './field.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';

@classNames('row')
export default class PracticeWebsiteEditMenuField extends Component {}
